import { createContext } from 'react';
import {
  LargeCategorySchema,
  MiddleCategorySchema,
  SmallCategorySchema,
  TinyCategorySchema,
} from 'src/models/category/schema';

export type Category = {
  largeCategories: LargeCategorySchema[];
  middleCategories: MiddleCategorySchema[];
  smallCategories: SmallCategorySchema[];
  tinyCategories: TinyCategorySchema[];
};

export const CategoryContext = createContext({} as Category);
